import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useSession } from "../../state/session-context";

export function RequirePermission({
  permission,
  children,
}: {
  permission: string;
  children: ReactNode;
}): ReactNode {
  const { hasPermission } = useSession();
  if (!hasPermission(permission)) {
    return <Navigate to="/" replace />;
  }
  return children;
}
